// extracted by mini-css-extract-plugin
export default {"contact":"Contact_contact__UkOYk","title":"Contact_title__CjNdO","cform":"Contact_cform__x4uxi","contact-form":"Contact_contact-form__4RNel","content":"Contact_content__Em9Lc"};